import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IMei from "Types/IMei";
import { State } from "store/reducers";

export const CREATE_COMPANY = "[COMPANY CREATE] CREATE_COMPANY";
export const CREATE_COMPANY_SUCCESS =
	"[COMPANY CREATE] CREATE_COMPANY_SUCCESS";
export const CREATE_COMPANY_FAILED =
	"[COMPANY CREATE] CREATE_COMPANY_FAILED";

export const SET_VALUE = "[COMPANY CREATE] SET_VALUE";
export const CLEAR_VALUES = "[COMPANY CREATE] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function createCompany(callback: Callback<IMei>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CREATE_COMPANY });

		try {
            const { login, companyCreate } = getState() as State;

            const { businessName, socialName, cnpj, code } = companyCreate as any;

			const errors: any = {};

			dispatch(setValue({ errors }));

			if (Object.keys(errors).length)
				return dispatch({ type: SET_VALUE, payload: { loading: false } });

            const model = {
                businessName,
                socialName,
                cnpj,
                code,
                type: 1
            } as Partial<IMei>;

			const response = await api.sendPost("/Mei", model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: CREATE_COMPANY_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: CREATE_COMPANY_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: CREATE_COMPANY_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
